export const HIGHLIGHT_TYPES = {
  FOOTING: 'footing',
  INCONSISTENCY: 'inconsistency',
};

export const HIGHLIGHT_COLORS = {
  [HIGHLIGHT_TYPES.FOOTING]: {
    correct: {
      background: 'rgba(219, 244, 181, 0.6)',
      border: '#8BC34A',
    },
    error: {
      background: 'rgba(255, 194, 190, 0.6)',
      border: '#E44F40',
    },
  },
  [HIGHLIGHT_TYPES.INCONSISTENCY]: {
    error: {
      background: 'rgba(255, 194, 190, 0.6)',
      border: '#E44F40',
    },
  },
};

export const ACTIVE_HIGHLIGHT_STYLE = {
  border: '2px solid #E44F40',
  // boxShadow: '0 0 8px rgba(228, 79, 64, 0.5)',
  boxShadow: 'none',
};

export const OVERLAY_Z_INDEX = 100;
